import { SelectPro } from "components/ui/select-pro";
import React from "react";
import { getStatesArray } from "util/states";

interface DefaultStateSelectProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export const DefaultStateSelect: React.FC<DefaultStateSelectProps> = ({
    value,
    onChange,
    disabled,
}) => {
    return (
        <SelectPro
            label="Default state when searching for communities"
            includePlaceholderOption
            disabled={disabled}
            value={value}
            onChange={e => onChange(e.target.value)}
            options={getStatesArray()}
        />
    );
};
